export class LinkProvider {

    static latestIosApp = "itms-services://?action=download-manifest&url=https://smartdesk-resources.finconsgroup.com/Releases/iOS/smartDesk_manifest.plist";
    static latestAndroidApp = "https://smartdesk-resources.finconsgroup.com/Releases/Android/smartDesk.apk";

    static latestIosDocument = "https://smartdesk-resources.finconsgroup.com/Resources/ios_guide.pdf";
    static latestAndroidDocument = "https://smartdesk-resources.finconsgroup.com/Resources/android_guide.pdf";

    static quickGuide = "https://smartdesk-resources.finconsgroup.com/Resources/sdeskQuickGuide.pdf";
}
